@use '~@frontrow/console/css/variables.scss';

.newLicenseContainer {
  display: flex;
  align-items: center;
  font-size: variables.$font-size-sm;
  margin-top: variables.$std-margin-md;
}

.licenseDetail {
  margin-right: variables.$std-margin-lg;
}

.addLicenseButton {
  margin-top: variables.$std-margin-xs;
  height: 100%;
}

.deleteButton {
  margin-top: variables.$std-margin-xs;
  margin-right: variables.$std-margin-sm;
}

.dateFieldWrapper {
  :global {
    .SingleDatePickerInput {
      padding-right: 0;
      display: flex;
      width: 220px;
    }
  }
}

.licenseCountFieldWrapper {
  width: 150px;
}
